<div class="ap-margin-bottom-3">
    {{ 'extra-asset.selling-price.amount' | coApplicantPipe: store.hasCoApplicant | apContent }}
</div>

<ap-amount-input
    id="sellingPrice"
    [helpText]="'extra-asset.selling-price.amount.help-text' | apContent"
    [showSymbol]="true"
    [numberOfDecimals]="0"
    [formControl]="mainApplicantControl"
></ap-amount-input>

<additional-info
    [key]="questionKey"
    titleKey="extra-asset.selling-price.amount.additional-info.text"
    contentKey="extra-asset.selling-price.amount.additional-info.content"
    modalUrlKey="extra-asset.selling-price.amount.additional-info.text"
></additional-info>

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()"></next-button>
}
